const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const dayCounts = [
    '31',
    '29',
    '31',
    '30',
    '31',
    '30',
    '31',
    '31',
    '30',
    '31',
    '30',
    '31',
  ];

  function updateDayContainer(selectedMonth, dayContainer) {
    const monthIndex = months.indexOf(selectedMonth); 
    const daysInMonth = dayCounts[monthIndex];

    dayContainer.classList.remove('hide-29-plus', 'hide-30-plus');

    if (daysInMonth < 30) {
        dayContainer.classList.add('hide-29-plus');
    } else if (daysInMonth < 31) {
        dayContainer.classList.add('hide-30-plus');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const openTriggers = document.querySelectorAll('.date-selection-open-trigger');
    const monthContainer = document.querySelector('.js-date-picker__month-picker');
    const dayContainer = document.querySelector('.js-date-picker__day-picker');
    const days = document.querySelectorAll('.js-date-picker__day');
    const today = new Date();
    let activeMonth, closeDays = false;
    let selectedMonth = months[today.getMonth()];
    let selectedDay = "1st";
    updateDayContainer(selectedMonth, dayContainer);

    openTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        activeMonth = monthContainer.querySelector('button.selected');

        if(activeMonth && activeMonth != trigger) {
          activeMonth.classList.remove('selected');
          activeMonth = undefined;
        }

        if(trigger.classList.contains('selected')) {
          trigger.classList.remove('selected');
          dayContainer.ariaHidden = 'true';
        }
        else {
          trigger.classList.add('selected');
          dayContainer.ariaHidden = 'false';
        }
        
        if(trigger.dataset.month) {
          selectedMonth = trigger.dataset.month;
          updateDayContainer(selectedMonth, dayContainer);
        }
        else {
          monthContainer.querySelector(`[data-month=${selectedMonth}]`).classList.add('selected');
        }
      });
    });
    days.forEach((day) => {
      day.addEventListener('click', (e) => {
        e.preventDefault();
        day.classList.add('selected');
        if(day.dataset.day) {
          selectedDay = day.dataset.day;
        }
        window.location.href = `/products/${selectedMonth.toLowerCase()}-${selectedDay.toLowerCase()}-birthdate-scented-candle`;
      });
    });
  });